import { Component, Input, OnInit } from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'

@Component({
  selector: 'app-linha-pesquisa',
  templateUrl: 'linha-pesquisa.component.html',
  styleUrls: ['./linha-pesquisa.component.scss'],
  imports: [
    MatTableModule,
  ]
})
export class LinhaPesquisaComponent implements OnInit {

  @Input() data: string[] = []

  linhas = new MatTableDataSource<string>()
  linhaColumns: string[] = ['nome']

  constructor() {
  }

  ngOnInit(): void {
    this.linhas.data = this.data
  }

}